import { SlotProvider } from '@media-platform/slot/src/react';
import { counterTrigger, AnalyticCounters } from 'Tools/counters';
import { attachChildrenToDWH, initDWHLogger, reinitDWHLogger, } from 'Tools/dwhLogger';
import 'Tools/xray';
import { pushToWeborama } from 'Src/tools/weborama';
import Diafilm from '@media-ui/pypo-article/src/containers/Diafilm';
import type * as T from './index.types';
void initDWHLogger();
const DiafilmApp: React.FunctionComponent<T.IDiafilmAppProps> = (props) => {
    const { page_data, layout } = props;
    const { rb } = layout;
    const { media_stat, article: diafilm } = page_data;
    pushToWeborama('diafilm', 'yes');
    let diafilmAuthor;
    if (diafilm && diafilm.authors && diafilm.authors.length) {
        diafilmAuthor = diafilm.authors[0];
    }
    const defaultSlotParams: T.IDiafilmSlotParams = {
        entity_id: media_stat?.entity_id,
        entity_type: media_stat?.entity_type,
        brandsafety: rb?.brandsafety ? '1' : '0',
        is_commercial: diafilm.is_commercial ? '1' : '0',
    };
    let commercialParams;
    if (diafilm && diafilm.commercial && diafilm.commercial.string_id) {
        commercialParams = {
            _STRING: diafilm.commercial.string_id,
        };
    }
    const ownProps: T.IDiafilmAppOwn = {
        projectLogo: {
            attrs: {
                name: '',
            },
            height: 24,
            width: 125,
            href: 'https://pets.mail.ru',
            image: '/img/logo/pets/pets_logo_light.svg',
            title: 'Питомцы Mail',
        },
        shares: {
            buttons: [
                {
                    socialId: 'ok',
                },
                {
                    socialId: 'vk',
                },
            ],
        },
        onMenuMount: (element) => {
            if (element && element.current) {
                attachChildrenToDWH({ root: element.current });
            }
        },
        slideProps: {
            start: {
                label: diafilm && diafilm.is_commercial
                    ? {
                        text: 'Партнерский материал',
                    }
                    : undefined,
                author: diafilmAuthor,
            },
        },
        mediaStatProps: media_stat,
        sliderAfterChange: (slide: T.IDiafilmAppItem) => {
            // Дергаем счетчики страницы при переходе на слайд
            AnalyticCounters.triggerAll();
            if (slide.attrs.counter) {
                counterTrigger('diafilmSlide', { id: slide.attrs.counter });
            }
            const currentSlide = document.querySelector('[data-qa="Diafilm"] .media-ui-slider .media-ui-slider-current');
            reinitDWHLogger({
                root: currentSlide,
                config: {
                    asyncTarget: 'gallery',
                    options: {
                        url: window.location.href,
                    },
                },
            });
        },
        sliderOnInit: (slide: T.IDiafilmAppItem) => {
            // Счетчик на показ диафильма
            if (slide.attrs.counter) {
                counterTrigger('diafilmSlide', { id: slide.attrs.counter });
            }
        },
        // слот партнера справа
        slotHead: {
            id: '1358762',
            params: commercialParams,
        },
        // слот партнера в меню
        slotMenu: {
            id: '1358761',
            params: commercialParams,
        },
    };
    const diafilmData: T.IArticleDiafilmProps = {
        ...diafilm,
        ...ownProps,
        isCommercial: diafilm.is_commercial,
    };
    return (<SlotProvider siteid={rb.site_id} defaultParams={defaultSlotParams}>
      <Diafilm {...diafilmData}/>
    </SlotProvider>);
};
export default DiafilmApp;
